import type React from 'react';
import Form from 'react-bootstrap/Form';
import InputDecorator from '@enerex/unified-ui-react/form/InputDecorator';

type UnifiedTextInputProps = {
    type?: 'text' | 'email' | 'number';
    name?: string;
    control?: any;
    rules?: Record<string, any>;
    label?: React.ReactNode;
    labelClassName?: string;
    containerClass?: string;
    inputClassName?: string;
    placeholder?: string;
    disabled?: boolean;
    loading?: boolean;
    defaultValue?: any;
    value?: any;
    autoComplete?: string;
    onWheel?: (event: React.WheelEvent<HTMLInputElement>) => void;
    onChange?: (value: any) => void;
    errors?: Record<string, any>;
    isInvalid?: boolean;
    [key: string]: any;
};

const UnifiedTextInput = ({
    type = 'text',
    name,
    control,
    rules,
    label,
    labelClassName,
    containerClass,
    inputClassName,
    placeholder,
    disabled,
    loading,
    defaultValue = '',
    value,
    autoComplete,
    onWheel,
    onChange,
    errors,
    isInvalid,
    ...props
}: UnifiedTextInputProps) => {
    if (!control) {
        const invalid = isInvalid || (name ? Boolean(errors?.[name]) : false);

        return (
            <Form.Group className={containerClass}>
                {label ? (
                    <Form.Label className={labelClassName}>{label}</Form.Label>
                ) : null}
                <Form.Control
                    {...props}
                    type={type}
                    name={name}
                    id={name}
                    placeholder={placeholder}
                    className={inputClassName}
                    disabled={disabled}
                    isInvalid={invalid}
                    autoComplete={autoComplete || name}
                    {...(value !== undefined
                        ? { value }
                        : { defaultValue })}
                    onChange={(event) => onChange?.(event)}
                    onWheel={onWheel}
                />
                {name && errors?.[name] ? (
                    <Form.Control.Feedback type="invalid">
                        {errors[name]?.message as string}
                    </Form.Control.Feedback>
                ) : null}
            </Form.Group>
        );
    }

    return (
        <InputDecorator
            name={name as string}
            control={control}
            rules={rules}
            label={label}
            labelClassName={labelClassName}
            containerClass={containerClass}
            loading={loading}
            defaultValue={defaultValue}
            render={({ field, fieldState: { invalid } }) => (
                <Form.Control
                    {...field}
                    {...props}
                    type={type}
                    placeholder={placeholder}
                    className={inputClassName}
                    disabled={disabled}
                    isInvalid={invalid}
                    autoComplete={autoComplete || name}
                    onChange={(event) => {
                        field.onChange(event);
                        onChange?.(event);
                    }}
                    onWheel={onWheel}
                />
            )}
        />
    );
};

export default UnifiedTextInput;
